import styled from "styled-components";
import { palette } from "styled-theme";

const SchedulingWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: auto;
  &.fullscreen {
    /* padding-top: 40px; */
  }
  &.surface {
    background-color: ${palette("surfaceColor", 0)};
    padding: ${(props) => (props["padding"] === true ? "32px" : "24px")};
    margin: ${(props) => (props["noMargin"] === true ? "0px" : "20px")};
    box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    border-top-left-radius: ${(props) =>
      props["noTop"] === true ? "0" : "5px"};
    border-top-right-radius: ${(props) =>
      props["noTop"] === true ? "0" : "5px"};
  }
`;

export default SchedulingWrapper;
